/**
 * TODO: CSS Variables に移行すること
 */
export const TRANSITION_DURATION = '.2s'
export const OPACITY_HOVER = '.7'
